'use client'; // Error components must be Client Components
import { GenericError } from '@capsicum/common-web';

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
	return <GenericError error={error} reset={reset} />;
}
